<div *ngIf="loading === true" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>
<app-supplier-form (afterSave)="afterSave($event)"></app-supplier-form>
